/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyMonero = createReactComponent("outline", "currency-monero", "IconCurrencyMonero", [["path", { "d": "M3 18h3v-11l6 7l6 -7v11h3", "key": "svg-0" }]]);

export { IconCurrencyMonero as default };
//# sourceMappingURL=IconCurrencyMonero.mjs.map
